import * as React from "react";

import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { trpcUtils } from "@editor/utils/trpc";

import {
  CustomFontsView,
  useFontUpload,
} from "@/editor/components/shops-ui/settings/shop/FontManager";
import Button from "@replo/design-system/components/button/Button";
import IconButton from "@replo/design-system/components/button/IconButton";
import { ArrowLeft } from "lucide-react";

interface DesignLibraryCustomFontsProps {
  onBack?: () => void;
}

export const DesignLibraryCustomFonts: React.FC<
  DesignLibraryCustomFontsProps
> = ({ onBack }) => {
  const projectId = useCurrentProjectId();
  const utils = trpcUtils;
  const fontUploadHook = useFontUpload(projectId);
  const { triggerUpload, fileInputElement, processFiles, isUploading } =
    fontUploadHook;

  return (
    <div className="flex flex-col items-start flex-[1_0_0] self-stretch min-h-0 rounded-xl border border-border bg-white shadow-button-selectable">
      <div className="flex justify-between items-center self-stretch p-6 border-b-0.5 border-border">
        <div className="flex items-center gap-3">
          <IconButton
            variant="secondary"
            size="sm"
            layoutClassName="h-6 w-6"
            icon={<ArrowLeft size={16} className="text-default" />}
            onClick={() => {
              if (projectId) {
                void utils.webContainer.getFileTree.invalidate({ projectId });
              }
              onBack?.();
            }}
          />
          <div className="text-lg font-semibold">Custom Fonts</div>
        </div>
        <Button variant="secondary" size="sm" onClick={triggerUpload}>
          Upload Fonts
        </Button>
        {fileInputElement}
      </div>
      <div className="flex flex-1 flex-col self-stretch overflow-y-auto no-scrollbar p-6">
        <CustomFontsView fontUploadHook={{ processFiles, isUploading }} />
      </div>
    </div>
  );
};
